// This function wraps a thunk and catches any uncaught errors,
export default cb => async (dispatch, getState) => {
  return cb(dispatch, getState).catch(error => {
    console.error('[Error]', error);
  });
};



// WEBPACK FOOTER //
// ./src/modules/wrap-thunk.js